<div class="displayLibsCenter" fxFlex="33"
     fxLayout="column" fxLayoutAlign="center center">
  <app-forgot-password [apiEndpoint]="endPoint"
                       [successLink]="'login'"
                       [returnLink]="'login'"
                       [logoStyle]="logoStyle"
                       [imageSrc]="'../../../assets/logos/saCentre.png'"
                       [secondaryHeader]="'Please check your email for your verification code.'"
                       [cardWidth]="'500px'"></app-forgot-password>

</div>

<!--


[returnLink]="'/auth/login'" [successLink]="'auth/reset-password'"
[logoImage]="'../../../../assets/grapes.png'"
[passwordResetRequiredLink]="'/auth/reset-admin-password'"
[apiEndpoint]="endPoint"-->
